import CryptoJS from 'crypto-js';
import { PersistStorage, StorageValue } from 'zustand/middleware';

import { ENV } from '@/constants/env';

export class EncryptedStorage<S> implements PersistStorage<S> {
    getItem(key: string): StorageValue<S> | null {
        const value = localStorage.getItem(key);

        if (value !== null) {
            const decryptedString = CryptoJS.AES.decrypt(value, ENV.APP_SECRET).toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedString);
        }

        return value;
    }

    setItem(key: string, value: StorageValue<S>) {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), ENV.APP_SECRET).toString();
        localStorage.setItem(key, encrypted);
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }
}
